export const BUSINESS_PEPPER_ASSIGNMENT_STAGE = {
  WRI_AWA: {
    id: 'WRI_AWA',
    title: 'In Progress',
    color: 'cyan'
  },
  WRI_WRK: {
    id: 'WRI_WRK',
    title: 'In Progress',
    color: 'cyan'
  },
  EDO_AWA: {
    id: 'EDO_AWA',
    title: 'In Progress',
    color: 'cyan'
  },
  EDI_AWA: {
    id: 'EDI_AWA',
    title: 'In Progress',
    color: 'cyan'
  },
  EDI_WRK: {
    id: 'EDI_WRK',
    title: 'In Progress',
    color: 'cyan'
  },
  EDO_FIN: {
    id: 'EDO_FIN',
    title: 'In Progress',
    color: 'cyan'
  },
  CLO_FIN: {
    id: 'CLO_FIN',
    title: 'In Progress',
    color: 'cyan'
  },
  CLI_AWA: {
    id: 'CLI_AWA',
    title: 'Approval Pending',
    color: 'gold'
  },
  CLI_FIN: {
    id: 'CLI_FIN',
    title: 'Approved',
    color: 'green'
  }
}
